/**
 * eJOY AI Dictionary — in-page translation / vocabulary learning
 *
 * Declares one web-accessible-resource entry matched to http(s) origins (and file URLs)
 * with no `use_dynamic_url`, exposing globs including `video/*.js` and `assets/css/*.css`.
 * The per-streaming-service adapters under `video/` are vendor-specific and stably named
 * (`video/netflix.js`, `video/coursera.js`), so a fetch of one is conclusive. There is no
 * image WAR, so the primary signal is a fetch of a `video/` adapter.
 *
 * Manifest verified against version 7.1.46.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'amfojhdiedpdnlijjbhjnhokbnohfdfb';

export const ejoyAiDictionary: ExtensionDefinition = {
  id: ID,
  name: 'eJOY AI Dictionary',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Static WAR globs (video/*.js, assets/css/*.css) on http(s) origins with no dynamic ' +
    'URL. The stably-named video/ adapters make a single fetch conclusive.',
  signals: [
    {
      id: 'war-video-netflix-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch video/netflix.js — a vendor-specific streaming adapter exposed to every ' +
        'http(s) origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'video/netflix.js'),
    },
    {
      id: 'war-video-coursera-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch video/coursera.js — a second stably-named adapter corroborating the ' +
        'identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'video/coursera.js'),
    },
    {
      id: 'war-popup-chunk-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/css/popup.chunk.css — a stylesheet path independent of the ' +
        'video adapters.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/css/popup.chunk.css'),
    },
  ],
};
